import { createContext, useContext } from "react";

/**
 * SidebarStateContext — plumbed by AppShell so any page can toggle
 * the app sidebar visibility. `collapsed` reflects the desktop
 * localStorage-persisted rail state; `mobileNavOpen` reflects the
 * mobile drawer.
 *
 * Default values are safe no-ops so consumers can call the hook
 * outside of AppShell (e.g. in an isolated Storybook) without errors.
 */
export const SidebarStateContext = createContext({
  collapsed:        false,
  setCollapsed:     () => {},
  toggleCollapsed:  () => {},
  mobileNavOpen:    false,
  setMobileNavOpen: () => {},
});

export function useSidebarState() {
  return useContext(SidebarStateContext);
}
